<template>
  <div>
    <!-- <BottomSheetModal ref="component" > -->
    <ModalComponent
      ref="modal"
      class="[&_.w-screen>.flex.p-4]:!p-0 [&_.w-screen]:!overflow-hidden [&_.boxComponent]:!bg-transparent [&_.boxComponent]:!w-[100%] [&_.boxComponent]:!h-[100vh] [&_.boxComponent]:!max-w-[100%] [&_.boxComponent]:!max-h-[100vh] [&_.boxComponent]:!rounded-none [&_.boxComponent>div>div]:!p-0"
    >
      <template #header>
        <div></div>
      </template>
      <template #fullContent>
        <div
          class="relative h-[100svh] top-0 left-0 bg-[#1E1C2A] flex flex-col title-color overflow-auto"
        >
          <div class="flex gap-2 items-center p-6 px-8 pb-0 sticky top-0">
            <div class="w-14 h-14 p-1">
              <img src="/images/tv.png" class="w-full h-full object-contain" />
            </div>
            <div class="top-0 text-2xl font-bold relative">
              <div
                class="w-8 top-0 right-0 absolute translate-x-2/3 -translate-y-1/2"
              >
                <img
                  src="@/assets/images/king-recharge-assets/crown-white.svg"
                  class="w-full"
                  alt=""
                />
              </div>
              <div>Kingrecharge Tv</div>
            </div>
            <div class="ml-auto">
              <div class="w-8 h-8 right-2 top-2" @click="$router.back()">
                <img src="@/assets/images/all/close-white.svg" alt="" />
              </div>
            </div>
          </div>
          <div class="pt-1"></div>
          <div class="px-8 overflow-auto">
            <div class="py-4"></div>
            <TvList @watchTvRequested="selectTv" />
          </div>
          <div class="py-1"></div>
          <div class="absolute w-full h-full top-0 left-0" v-if="activeTv">
            <div
              class="absolute w-8 h-8 right-2 top-2 z-[32]"
              @click="activeTv = null"
            >
              <img src="@/assets/images/all/close-white.svg" alt="" />
            </div>
            <TvScreen
              class="absolute"
              :channel="activeTv"
              :key="activeTv.id"
              @channelListRequested="
                () => {
                  $refs.channelListSide.showList()
                }
              "
            />
            <TvListSide
              class="absolute"
              ref="channelListSide"
              :activeTv="activeTv"
              @watchTvRequested="selectTv"
            />
          </div>
        </div>
      </template>
    </ModalComponent>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from '@/components/utils/ModalComponent.vue'
import ColorImg from '@/components/utils/ColorImg.vue'
import TvList from './TvList.vue'
import TvScreen from './TvScreen.vue'
import TvListSide from './TvListSide.vue'

export default defineComponent({
  name: 'TvsModal',
  components: { ModalComponent, ColorImg, TvList, TvScreen, TvListSide },
  props: {},
  data() {
    return {
      activeTv: null,
      eventsIds: [],
    }
  },
  mounted() {
    const id = this.$Events.handleEvent('start_tv_required', this.startTv)
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    startTv() {
      this.activeTv = null
      this.$refs.modal.show()
      this.$Commons.setThemeColor('#242c3b')
      setTimeout(() => {
        this.$Commons.setThemeColor('#242c3b')
      }, 500)
    },
    selectTv(tv) {
      this.activeTv = tv
    },
  },
  computed: {},
})
</script>
